export default "__VITE_ASSET__DxQBKoi1__"